interface Props {
  connected: boolean;
  starting: boolean;
  micOn: boolean;
  camOn: boolean;
  onStart: () => void;
  onStop: () => void;
  onRestart: () => void;
  onToggleMic: () => void;
  onToggleCam: () => void;
}

export function Controls({
  connected,
  starting,
  micOn,
  camOn,
  onStart,
  onStop,
  onRestart,
  onToggleMic,
  onToggleCam,
}: Props) {
  return (
    <div className="controls">
      {!connected ? (
        <button
          className="btn btn--primary"
          onClick={onStart}
          disabled={starting}
        >
          {starting ? "Connecting…" : "Start conversation"}
        </button>
      ) : (
        <>
          <button className="btn" onClick={onToggleMic} aria-pressed={!micOn}>
            {micOn ? "Mute" : "Unmute"}
          </button>
          <button className="btn" onClick={onToggleCam} aria-pressed={!camOn}>
            {camOn ? "Camera off" : "Camera on"}
          </button>
          <button className="btn" onClick={onRestart}>
            Restart
          </button>
          <button className="btn btn--danger" onClick={onStop}>
            End
          </button>
        </>
      )}
    </div>
  );
}
